import { createAction, props } from '@ngrx/store';

export enum ExcelImporterActionTypes {
  Create_UI_ExcelColumn_Map = '[ExcelImport] UIExcelMap',
  Initialize_UI_Excel_Object = '[ExcelImport] InitializeUIExcelObject',
  Add_Calc_Field = '[ExcelImport] AddCalcField',
  Delete_Calc_Field = '[ExcelImport] DeleteCalcField',
  Add_Calc_Field_Value = '[ExcelImport] AddCalcFieldValue',
  Add_Row_In_Tab = '[ExcelImport] AddRowInTab',
  Add_Column_In_Row = '[ExcelImport] AddColumnInRow',
  Remove_UI_Excel_Object = '[ExcelImport] RemoveUIExcelObject'
}

export const createUIExcelColumnMap = createAction(
  ExcelImporterActionTypes.Create_UI_ExcelColumn_Map,
  props<{ dropEvent: any; actionType: string }>()
);
export const initializeUIExcelColumnObj = createAction(
  ExcelImporterActionTypes.Initialize_UI_Excel_Object,
  props<{ uiTabs: any; excelColumns: any; excelUploadResponse: any }>()
);
export const addCalcFieldInColumn = createAction(
  ExcelImporterActionTypes.Add_Calc_Field,
  props<{ cardColumn: any; fieldType: any }>()
);
export const deleteCalcFieldInColumn = createAction(
  ExcelImporterActionTypes.Delete_Calc_Field,
  props<{ cardColumn: any; index: number }>()
);
export const addCalcFieldValue = createAction(
  ExcelImporterActionTypes.Add_Calc_Field_Value,
  props<{ cardColumn: any; index: number; fieldValue: any }>()
);
export const addRowInTab = createAction(
  ExcelImporterActionTypes.Add_Row_In_Tab,
  props<{ actionIndex: number; tabIndex: number }>()
);
export const addColumnInRow = createAction(
  ExcelImporterActionTypes.Add_Column_In_Row,
  props<{ tabIndex: number; rowIndex: number; colIndex: number; colActionIndex: number }>()
);
export const removeUIExcelColumnObj = createAction(ExcelImporterActionTypes.Remove_UI_Excel_Object, props<{flag?:any}>());
